import React from 'react'

import type { AnalyticsReportsItem } from '../../AnalyticsReports.types'
import { ReportExportButton } from '../ReportExportButton/ReportExportButton'
import { ReportName } from '../ReportName/ReportName'
import * as S from './AnalyticsReportsListItem.styled'

type AnalyticsReportsListItemProps = {
  item: AnalyticsReportsItem
  precision: string
  onExport: () => Promise<void>
}
export const AnalyticsReportsListItem = ({
  item,
  precision,
  onExport,
}: AnalyticsReportsListItemProps) => {
  return (
    <S.Container>
      <ReportName name={item.name} externalSource={item.externalSource} />
      <ReportExportButton
        disabled={!item.supportsSelectedPrecision}
        tooltipMessage={`${item.name} report cannot be downloaded, because it does not support ${precision} grouping`}
        onExport={onExport}
      />
    </S.Container>
  )
}
